import { gql } from '@apollo/client';

// Paginated vendors
export const IPP_VENDORS = gql`
  query IppVendors($page: Int!, $limit: Int!, $orderBy: IppVendorsOrderBy, $sort: SortOrder) {
    ippVendorsPaginated(page: $page, limit: $limit, orderBy: $orderBy, sort: $sort) {
      totalCount
      pageInfo {
        currentPage
        totalPages
        hasNextPage
        hasPreviousPage
      }
      nodes {
        id
        vendorName
         vendorContactNumber
        vendorAddress
        vendorEmailId
        vendorEmailId1
  vendorEmailId2
        vendorEmailId3
        purchaseOrderNo
        needDetailsWithInvoice
        applyHst
         commercialStatus
        contactName
        departmentName
        poCalendarYear
        vendorDueDate
        vendorInvoicePrefix
        commercialOperationDate
        statusDate
        isCounterParty
        sharedMeterNumber
        cibPercentage
      }
    }
  }
`;

// Single vendor by id — used by the "View Co-party" blade to show a co-party
// vendor's read-only details without navigating away from the primary
// vendor's own edit page.
export const IPP_VENDOR = gql`
  query IppVendor($id: Int!) {
    ippVendor(id: $id) {
      id
      vendorName
      vendorContactNumber
      vendorAddress
      vendorEmailId
      vendorEmailId1
      vendorEmailId2
      vendorEmailId3
      purchaseOrderNo
      commercialStatus
      contactName
      departmentName
      poCalendarYear
      vendorDueDate
      vendorInvoicePrefix
      commercialOperationDate
      statusDate
      isCounterParty
      sharedMeterNumber
      cibPercentage
      secondaryVendorType
      secondaryIppGlNumber
    }
  }
`;

// Fallback simple query
export const IPP_VENDORS_SIMPLE = gql`
  query IppVendorsSimple {
    ippVendors {
      id
      vendorName
      vendorContactNumber
      vendorAddress
      vendorEmailId
      purchaseOrderNo
      needDetailsWithInvoice
    }
  }
`;

// Mutations
export const CREATE_IPP_VENDOR = gql`
  mutation CreateIppVendor($input: CreateIppVendorInput!) {
    createIppVendor(input: $input) {
      id
      vendorName
      vendorContactNumber
      vendorAddress
      vendorEmailId
      vendorEmailId1
      vendorEmailId2
      vendorEmailId3
      purchaseOrderNo
      needDetailsWithInvoice
      commercialStatus
      contactName
      departmentName
      poCalendarYear
      vendorDueDate
      vendorInvoicePrefix
      commercialOperationDate
      statusDate
    }
  }
`;

export const UPDATE_IPP_VENDOR = gql`
  mutation UpdateIppVendor($id: Int!, $input: UpdateIppVendorInput!) {
    updateIppVendor(id: $id, input: $input) {
      id
      vendorName
      vendorContactNumber
      vendorAddress
      vendorEmailId
      vendorEmailId1
      vendorEmailId2
      vendorEmailId3
      purchaseOrderNo
      needDetailsWithInvoice
      commercialStatus
      contactName
      departmentName
      poCalendarYear
      vendorDueDate
      vendorInvoicePrefix
      commercialOperationDate
      statusDate
    }
  }
`;

export const DELETE_IPP_VENDOR = gql`
  mutation DeleteIppVendor($id: Int!) {
    deleteIppVendor(id: $id)
  }
`;
